export class FixedSizeLifoQueue {
  constructor(capacity) {
    if (capacity <= 0) {
      throw new Error("Capacity must be a positive integer.");
    }
    this.capacity = capacity;
    this.store = new Array(capacity);
    this.top = -1; // Index of the top element
    this.count = 0;
  }

  push(item) {
    if (this.isFull()) {
      // Overwrite the oldest element (bottom of stack)
      // Shift all elements down by one, drop the bottom
      for (let i = 0; i < this.capacity - 1; i++) {
        this.store[i] = this.store[i + 1];
      }
      this.store[this.top] = item;
      // top remains at capacity - 1
    } else {
      this.top++;
      this.store[this.top] = item;
      this.count++;
    }
  }

  pop() {
    if (this.isEmpty()) {
      return undefined;
    }
    const item = this.store[this.top];
    this.store[this.top] = undefined;
    this.top--;
    this.count--;
    return item;
  }

  peek() {
    return this.isEmpty() ? undefined : this.store[this.top];
  }

  isEmpty() {
    return this.count === 0;
  }

  isFull() {
    return this.count === this.capacity;
  }

  size() {
    return this.count;
  }

  clear() {
    this.store = new Array(this.capacity);
    this.top = -1;
    this.count = 0;
  }
}
